import { SearchParamsProvider } from 'components/search/search.context';
import { useLocationLoyaltyPerformanceSearchParams } from '../loyalty-performance-report.hooks';
import { useSearchParams } from 'components/search/search.hooks';
import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import LocationLoyaltyPerformanceAPIDetailsDrawer from 'components/drawers/location-loyalty-performance-api-details-drawer/location-loyalty-performance-api-details-drawer.component';
import { MultipleSearchQueryProvider } from 'components/search/search.context';
import { useSearchQuery } from 'components/search/search.hooks';
import {
  useLocationsPerformanceDataQuery,
  useLocationsPerformanceSummaryQuery,
} from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useTranslation } from 'react-i18next';
import {
  LocationPerformanceParams,
  LoyaltyPerformanceParamsDiff,
} from 'api/reports-service/reports-service.types';
import LocationLoyaltyPerformanceSummaryCards from './location-loyalty-performance-summary-cards/location-loyalty-performance-summary-cards.component';
import PerformanceDataGrid from '../performance-data-grid/performance-data-grid.component';
import { useGetPerformanceSearchResults } from '../performance-data-grid/performance-data-grid.hooks';

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(
    useLocationLoyaltyPerformanceSearchParams(),
  );
  return (
    <SearchParamsProvider value={searchParams}>
      <LocationLoyaltyPerformance />
    </SearchParamsProvider>
  );
};

const filteredSearchParams: LoyaltyPerformanceParamsDiff<LocationPerformanceParams> =
  [
    'granularity',
    // 'offerstatus',
    'offerIds',
    // 'campaignId',
    'datatype',
    'offerdatatype',
    'offertype',
  ];

const LocationLoyaltyPerformance = () => {
  const { t } = useTranslation();
  const locationsPerformanceSummaryQuery = useSearchQuery(
    useLocationsPerformanceSummaryQuery,
    { filteredSearchParams },
  );

  const { getSearchResults } = useGetPerformanceSearchResults();

  const locationsPerformanceDataQuery = useSearchQuery(
    useLocationsPerformanceDataQuery,
    {
      filteredSearchParams,
      getSearchResults: data =>
        getSearchResults(data?.stores, data?.total, 'locationId'),
    },
  );

  const { open, close, isOpen } = useDrawer();

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            locationsPerformanceSummaryQuery,
            locationsPerformanceDataQuery,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Stack spacing={2}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              lg: 'repeat(5, 1fr)',
            }}
            gap={2}
          >
            <LocationLoyaltyPerformanceSummaryCards />
          </Box>
        </Stack>
        <PerformanceDataGrid
          displayInfoHeaderName={t(
            'page.loyaltyPerformanceReport.tabs.locationLoyaltyPerformance.grid.locationName.label',
          )}
          queryName="locationsPerformanceDataQuery"
          data-testid="LocationLoyaltyPerformance.SearchDataGrid"
        />
        <LocationLoyaltyPerformanceAPIDetailsDrawer
          isOpen={isOpen}
          close={close}
        />
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
